import { createIcon } from '@chakra-ui/icons';

export const Hamburger = createIcon({
  displayName: 'Hamburger',
  viewBox: '0 0 26 20',
  path: [
    <svg fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 18.1429H25M1 9.57143H25M1 1H25"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>,
  ],
});
